export default __webpack_public_path__ + "static/media/sampleDog4.60600ade.jpg";